import { Link } from "react-router-dom";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { SectionHead } from "../components/SectionHead";
import { Marquee } from "../components/Marquee";
import { PRODUCTION_ITEMS, IMG } from "../data/content";

export default function Production() {
  return (
    <main>
      <PageHero
        eyebrow="Event Production"
        title="Built Behind the Scenes. Remembered from the Front Row."
        description="Stage, sound, lighting, visuals, timing and people — brought into one coordinated experience."
        image={IMG.production}
      />
      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <SectionHead eyebrow="Capability" title="Every Detail, One Coordinated Experience" />
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#C9A55C]/12 border border-[#C9A55C]/12">
            {PRODUCTION_ITEMS.map((item, i) => (
              <Reveal key={item} delay={(i % 3) * 0.06}>
                <div className="bg-[#0D1018] p-8 h-full hover:bg-[#11141f] transition-colors duration-500" data-testid={`production-item-${i}`}>
                  <p className="font-accent italic text-2xl text-[#C9A55C]/60">{String(i + 1).padStart(2, "0")}</p>
                  <h3 className="font-display text-xl text-[#F3EEE5] mt-4">{item}</h3>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <div className="mt-14 grid md:grid-cols-3 gap-6">
              {[IMG.stagePurple, IMG.production, IMG.backstage].map((src, i) => (
                <div key={i} className="img-frame aspect-[4/3] border border-[#C9A55C]/15">
                  <img src={src} alt="Event production showcase" className="w-full h-full object-cover" loading="lazy" />
                </div>
              ))}
            </div>
            <Link to="/plan-your-event" className="btn-gold mt-12 inline-flex" data-testid="production-cta-btn">
              Plan Your Production
            </Link>
          </Reveal>
        </div>
      </section>
      <Marquee />
    </main>
  );
}
